import {
  GetConfigFeedbacksEvaluationsResponse,
  UpdateFeedbacksEvaluationsConfig,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsFeedbacksEvaluationsService = {
  async list(): Promise<GetConfigFeedbacksEvaluationsResponse> {
    const response =
      await httpClient.get<GetConfigFeedbacksEvaluationsResponse>(
        "v1/config/feedbacks/evaluations",
      );
    return response;
  },
  async update(body: UpdateFeedbacksEvaluationsConfig): Promise<void> {
    await httpClient.patch("v1/config/feedbacks/evaluations", body);
  },
};

export default ConfigurationsFeedbacksEvaluationsService;
